import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { JsonResult } from '../core/json-result.model';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { GeographicalLocation } from '../models/localization/geographical-location.model';
import { EnvironmentService } from '../core/services/environment.service';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private commonService: CommonService) { }
  /**Lista departamentos */
  listDepartments(): Observable<JsonResult<GeographicalLocation[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}Localization/ListDepartments`;
    return this.httpClient.get<JsonResult<GeographicalLocation[]>>(url).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
  /**
   * Lista provincias
   * @param departmentCode Código de departamento 
   */
  listProvinces(departmentCode: string): Observable<JsonResult<GeographicalLocation[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}Localization/ListProvinces`;
    let params = new HttpParams();
    params = params.append("departmentCode", departmentCode)
    return this.httpClient.get<JsonResult<GeographicalLocation[]>>(url, { params: params }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
  /**
   * Lista distritos
   * @param provinceCode Código de provincia
   */
  listDistricts(provinceCode: string): Observable<JsonResult<GeographicalLocation[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}Localization/ListDistricts`;
    let params = new HttpParams();
    params = params.append("provinceCode", provinceCode)
    return this.httpClient.get<JsonResult<GeographicalLocation[]>>(url, { params: params }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }
}
